import { render, staticRenderFns } from "./article-detail.vue?vue&type=template&id=fca1e3e4&scoped=true"
import script from "./article-detail.vue?vue&type=script&lang=js"
export * from "./article-detail.vue?vue&type=script&lang=js"
import style0 from "./article-detail.vue?vue&type=style&index=0&id=fca1e3e4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca1e3e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fca1e3e4')) {
      api.createRecord('fca1e3e4', component.options)
    } else {
      api.reload('fca1e3e4', component.options)
    }
    module.hot.accept("./article-detail.vue?vue&type=template&id=fca1e3e4&scoped=true", function () {
      api.rerender('fca1e3e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/article-detail.vue"
export default component.exports